import protoRoot from "../proto-root";

const name = "setLowLightModeRPCRequest";

function create(lowLightMode) {
  const LowLightMode = protoRoot.lookupEnum("comm.LowLightMode");
  const SetLowLightModeRPCRequest = protoRoot.lookupType(
    "comm.SetLowLightModeRPCRequest"
  );
  const request = SetLowLightModeRPCRequest.create({
    lowLightMode: LowLightMode.values[lowLightMode]
  });

  return { payload: request, name };
}

export default {
  create,
  name
};

// message SetLowLightModeRPCRequest {
//     LowLightMode lowLightMode = 1;
//   }

// enum LowLightMode {
//     LL_OFF = 0;
//     LL_AUTO = 10;
//   }
